(() => {
	
	document.querySelectorAll('[nmc-toggle]').forEach((toggle) => {
		
		toggle.addEventListener('click', (e) => {
			e.preventDefault();
		
			if(!toggle.getAttribute('aria-controls')) { return; }

			const target = document.querySelector('#' + toggle.getAttribute('aria-controls'));
			
			if (!target) { return; }

			if (target.hasAttribute('hidden')) {
				target.removeAttribute('hidden');
				toggle.setAttribute('aria-expanded', 'true');
			} else {
				target.setAttribute('hidden', '');
				toggle.setAttribute('aria-expanded', 'false');
			}
		});

	});

})();